import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import weui from "weui.js";
import {
  changeCurrentMeter,
  selectCurrentMeterNo,
  selectMeters
} from "../stores";

/**
 * 表计选择 HOC
 * 为组件注入 showMeterPicker 方法, 之后可在组件内使用 this.props.showMeterPicker() 来显示表计选择界面.
 * 函数组件请直接使用 react-router-dom 中提供的 useNavigate 与 useLocation.
 * @param Component
 * @returns {function(*)}
 */
export const withMeterPicker = (Component) => {
  const HOC = (props) => {
    const meters = useSelector(selectMeters);
    const meterNo = useSelector(selectCurrentMeterNo);
    const dispatch = useDispatch();

    const showPicker = useCallback(() => {
      const items = meters.map(m => ({
        label: `${m.name}[${m.meterClass}]`,
        value: m.meterNo
      }));

      weui.picker(items, {
        defaultValue: [meterNo],
        onConfirm: values => {
          dispatch(changeCurrentMeter(values[0].value));
        }
      });
    }, [meters, meterNo, dispatch]);

    return <Component showMeterPicker={ showPicker } { ...props } />;
  };
  
  HOC.displayName = `WithMeterPicker(${Component.displayName || Component.name || "Component"})`;
  
  return HOC;
};
